import React from 'react';
import { connect } from 'react-redux';

import { toggleSnackBar } from 'apps/auth/actions/appAction';
import { Button } from 'apps/auth/components/common/Button/Button';
import { DetailsItem } from 'apps/auth/components/common/DetailsItem/DetailsItem';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import { canShareDetails, copyTextToClipboard, shareDetails } from 'apps/auth/helpers/utils';

const InteracSecretCodeModal = (props) => {
    return (
        <ModalComponent>
            <HeaderPanel title={props.notifyHeader} subtitle={props.interacNotifySubheader} />
            <Row indent="adaptive-32-48">
                <DetailsItem
                    detailsTitle={props.interacNotifyCodeLabel}
                    detailsText={props.cheque.secretCode}
                    detailsButton={props.interacNotifyCopyCode}
                    detailsButtonClick={() => {
                        const result = copyTextToClipboard(props.cheque.secretCode);
                        if (result) {
                            props.toggleSnackBar(true, `${props.interacNotifyCodeLabel} ${props.copied}`);
                        }
                    }}
                />
            </Row>
            {canShareDetails() && (
                <Button
                    type="button"
                    variant="row"
                    size="tight"
                    caption={props.shareDetailsLink}
                    onClick={(e) => {
                        e.preventDefault();
                        shareDetails(`${props.shareTitleDetails}`, `${props.cheque.shareDetails}`);
                    }}
                    negativeMargin
                />
            )}
        </ModalComponent>
    );
};
const mapStateToProps = (state) => {
    return {
        notifyHeader: state.messages.pageMessages.notifyHeader,
        interacNotifySubheader: state.messages.pageMessages.interacNotifySubheader,
        interacNotifyCodeLabel: state.messages.pageMessages.interacNotifyCodeLabel,
        interacNotifyCopyCode: state.messages.pageMessages.interacNotifyCopyCode,
        shareDetailsLink: state.messages.pageMessages.shareDetailsLink,
        shareTitleDetails: state.messages.pageMessages.shareTitleDetails,
        copied: state.messages.pageMessages.copied,
    };
};
export default connect(mapStateToProps, { toggleSnackBar })(InteracSecretCodeModal);
